// class groups

import Cursors from './cursors';
import Text from './text';

// class singles

import Badge from './badge/script';
import Hamburger from './hamburger/script';
import Image from './image/script';
import StickyElement from './sticky-element/script';

export default {
	...Cursors,
	...Text,

	[Badge.selector]: Badge,
	[Hamburger.selector]: Hamburger,
	[Image.selector]: Image,
	[StickyElement.selector]: StickyElement
};
